import React from 'react';
import './SubtitleTest.scss';

const SubtitleTest: React.FC = () => {
  return (
    <div className="container">
      <div className="fill screen-container">
        <div id="animation-1" className="animation">
          <div className="red">/</div>
          <div className="light mask">
            <div>Frederic</div>
          </div>
          <div className="light mask">
            <div>Colins</div>
          </div>
        </div>
      </div>
      <div className="key screen-container">
        <div id="animation-1" className="animation">
          <div className="red">/</div>
          <div className="light mask">
            <div>Frederic</div>
          </div>
          <div className="light mask">
            <div>Colins</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubtitleTest;
